interface ShowIfProps<T> {
  value: T | null | undefined;
  children: React.ReactNode | ((value: T) => JSX.Element | null);
}

export default function ShowIf<T>(props: ShowIfProps<T>): JSX.Element | null {
  if (props.value) {
    return typeof props.children === 'function'
      ? props.children(props.value)
      : props.children;
  }
  return null;
}
